import PropTypes from 'prop-types'
import React, { Component } from 'react'
import WrappedIntlComponent from '../common/intl/WrappedIntlComponent'
import Question from './components/Question/Question'
import './style.scss';
import {isEqual, orderBy} from 'lodash'
import Spiner from '../helpers/Spiner/Spiner';
import { getQuestions } from './actions';
import {AiFillCaretLeft, AiFillCaretRight} from 'react-icons/ai'
import { Button, Modal } from 'antd';
import PointProgress from './components/PointProgress/PointProgress';
import { IoMdHelp } from 'react-icons/io';
import classNames from 'classnames';
import {toastr} from 'react-redux-toastr'
import MetaTags from 'react-meta-tags';

function sortItem(list) {
  return orderBy(list, ['order'], ['asc'])
}

export class QuestionMultyView extends Component {
  constructor(props) {
    super(props)
  
    this.state = {
       question: null,
       loaded: false,
       questions: [],
       isAnswer: false,
       isShowDiscription: false,
       index: 0,
       answers: [],
       isFrame: false,
       help: false,
    }
  }

  async componentDidMount(){

    function inIframe () {
      try {
          return window.self !== window.top;
      } catch (e) {
          return true;
      }
    }


    try {
      let {questions, category} = await getQuestions(this.props.match.params.id);
      console.log("🚀 ~ file: QuestionMultyView.jsx:51 ~ QuestionMultyView ~ componentDidMount ~ category:", category)
      if(category){
        setTimeout(() => {
          document.title = category.name;
        }, 200);
        document.title = category.name;
      }
      questions = sortItem(questions);
      this.setState({
        questions,
        answers: questions.map(_i => null),
        question: questions[0] ? questions[0] : null,
        loaded: true,
        isFrame: inIframe(),
      })
    } catch (error) {
      
    }
    
  }


  clearAnswer = () => {
    const tmp = [...this.state.answers];
    tmp[this.state.index] = null;
    this.setState({answers: tmp})
  }

  sendAnswer = (value) => {
    const {answers, index, question} = this.state;
    let isTrue = false;

    if (question.question_type == 'type1') {
      isTrue = (question.answers || '').split(',').map(_i => (_i || '').toLowerCase().trim() ).includes((value || '').toLowerCase().trim());
    }

    if (question.question_type == 'type2') {
      const correctAnswer = question.answers.filter((_i) => _i.isTrue);
      isTrue = false;
      if (correctAnswer.length == value.length) {
        isTrue = !correctAnswer.some((_i) => !value.includes(_i._id));
      }
    }

    if (question.question_type == 'type3') {
      isTrue = isEqual(value, question.answers);
    }
    if (question.question_type == 'type5') {
      const answers = question.answers;
      const getValidateAnswer = (index) => {
        return (answers.variants[index] || '').split(',').map(_i => (_i || '').toLowerCase().trim() ).includes((value[index] || '').toLowerCase().trim())
      }
      isTrue = !answers.variants.some((_i, index) => !getValidateAnswer(index));
    }
    if (question.question_type == 'type4') {
      isTrue = true;
      const tmpAnswer = {};
      question.answers.forEach((_i) => {
        tmpAnswer[_i.title] = _i.variants;
      });
      Object.keys(tmpAnswer).forEach((key) => {
        if (value[key]) {
          tmpAnswer[key].forEach((v) => {
            const findEl = value[key].find((a_v) => isEqual(a_v, v));
            if (!findEl) {
              isTrue = false;
            }
          });
        } else {
          isTrue = false;
        }
      });
    }
    if (question.question_type == 'type6') {
      if(!Object.keys(value).some((key) => key != value[key]._id)){
        isTrue = true
      }
    }

    if (question.question_type == 'type7') {
      isTrue = !value.some(_i => _i._id != _i.answerId)
    }

    const tmp = [...answers];
    tmp[index] = isTrue;
    const {formatMessage} = this.props;

    if(isTrue){
      toastr.success(formatMessage('titleMsgAnswerOK'), formatMessage('bodyMsgAnswerOK'))
    } else {
      toastr.error(formatMessage('titleMsgAnswerError'), formatMessage('bodyMsgAnswerError'))
    }

    this.setState({
      isAnswer: true, 
      isShowDiscription: Boolean(this.state.question.description),
      answers: tmp
    })

  }

  nextAnswer = () => {

  }

  skip = (index) => {
    this.setState({
      index,
      question: this.state.questions[index],
      isAnswer: false,
      loaded: false,
      help: false
    }, () => {
      setTimeout(() => {
        this.setState({
          loaded: true
        })
      }, 200);
    })


  }
  
  render() {
    const {question, loaded, isAnswer, questions, index, isShowDiscription, answers, isFrame, help} = this.state;
    const {formatMessage} = this.props;

    if(!loaded){
      return <div className='QuestionMultyView'>
        <Spiner/>
      </div>
    }

    if(!question){
      return <div className='QuestionMultyView'>
      <h1 style={{textAlign: 'center', width: '100%'}}>{formatMessage('questiosIsNotFound')}</h1>
    </div>
    }


    return (
      <div className='QuestionMultyView'>
        <MetaTags>
          <title>Page 1</title>
          <meta name="description" content="Some description." />
          <meta property="og:title" content="MyApp" />
          <meta property="og:image" content="/images/active_learning.png" />
        </MetaTags>
        <Modal
          title={formatMessage('titleDescriptQuestionModal')}
          visible={isShowDiscription}
          footer={false}
          onCancel={() => {this.setState({isShowDiscription: false})}}
        >
          <div className='multyAnswerDesck' dangerouslySetInnerHTML={{
          __html: question ? question.description : '',
        }}/>
        <div style={{marginTop: 10, display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
          <Button type='primary' className='ant-btn-primary-circle' onClick={() => {this.setState({isShowDiscription: false})}}>{formatMessage('closeDescription')}</Button>
        </div>
        
        </Modal>
        <Button type="primary" shape="circle" style={{zIndex: 9999999}} disabled={index == 0} onClick={() => this.skip(index - 1)}>
          <AiFillCaretLeft size={20} />
        </Button>
        {question && <div className='block_question'>
          <Question
            formatMessage={formatMessage}
            help={help}
            clearAnswer={this.clearAnswer}
            question={question}
            questions={[question]}
            activeQuestion={0}
            sendAnswer={this.sendAnswer}
            skip={this.skip}
            nextAnswer={this.nextAnswer}
            isAnswer={isAnswer}
            onSetIsAnswer={(v) => {this.setState({isAnswer: v})}}
            onSetIsLoaded={(v) => {this.setState({loaded: v})}}
          />
          <PointProgress questions={questions} skip={this.skip} index={index} answers={answers}/>
          {isFrame && <a target="_blank" style={{marginTop: 10}} className='ant-btn ant-btn-primary-circle ant-btn-primary' href={window.location.href}>{formatMessage('openQuestion')}</a>}
        </div>}
        <Button type="primary" style={{zIndex: 9999999}} shape="circle" disabled={index == questions.length - 1} onClick={() => this.skip(index + 1)}>
          <AiFillCaretRight size={20} />
        </Button>
        {question && !['type1'].includes(question.question_type) && <div onClick={() => this.setState({help: !help})} className={classNames('help', {active: help})}>
          <IoMdHelp color={help ? '#00adff' : '#b4b4b4'} size={20} />
        </div>}
      </div>
    )
  }
}

export default WrappedIntlComponent(QuestionMultyView)


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/QuestionMultyView/QuestionMultyView.jsx